import { ShieldAlert } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { fetchSettings } from "@/lib/queries";

export function Disclaimer({ compact = false }: { compact?: boolean }) {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: fetchSettings });
  const text = data?.legal?.disclaimer ?? "";
  if (!text) return null;
  return (
    <div className={`flex gap-3 rounded-md border border-hairline bg-surface-2 p-3 text-xs leading-relaxed text-muted-foreground ${compact ? "" : "md:p-4 md:text-sm"}`}>
      <ShieldAlert className="mt-0.5 h-4 w-4 shrink-0 text-secondary" />
      <p>{text}</p>
    </div>
  );
}
